
const __default__ = {
  props: {
    items: {type: Array, default: () => []},
    name: {type: String, default: 'list'},
    duration: {type: Number, default: 0},
    gap: {type: String, default: '0'},
  },
  computed: {
    use_css(){
      return this.duration > 0
    }
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "fff771e2-gap": (_ctx.gap)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__